import { call, put, select, takeLatest } from "redux-saga/effects";

import type { FiCatalogResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";
import Organization from "@mapmycustomers/shared/types/Organization";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { removeFieldInsightsCharts } from "@app/store/fieldInsights/actions";
import { getOrganizationId } from "@app/store/iam/selectors";

import { fetchFieldInsightsChartVisibility, updateFieldInsightsChartVisibility } from "./actions";

function* onFetchFieldInsightsChartVisibility({
  payload,
}: ReturnType<typeof fetchFieldInsightsChartVisibility>) {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const response: ListResponse<FiCatalogResponse> = yield callApi(
      "fetchAllFieldInsightsCharts",
      orgId
    );
    yield call(payload.callback, response.data);
  } catch (error) {
    yield put(handleError({ displayNotification: payload.displayNotification ?? true, error }));
    if (payload.failureCallback) {
      yield call(payload.failureCallback);
    }
  }
}

function* onUpdateFieldInsightsChartVisibility({
  payload,
}: ReturnType<typeof updateFieldInsightsChartVisibility>) {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    yield callApi("updateFieldInsightsChartsVisibility", orgId, payload.charts);
    yield put(
      removeFieldInsightsCharts(
        payload.charts.filter(({ isHidden }) => isHidden).map(({ id }) => id)
      )
    );
    yield call(payload.callback);
  } catch (error) {
    yield put(handleError({ error }));
    if (payload.failureCallback) {
      yield call(payload.failureCallback);
    }
  }
}

export function* fieldInsightsChartVisibilitySaga() {
  yield takeLatest(fetchFieldInsightsChartVisibility, onFetchFieldInsightsChartVisibility);
  yield takeLatest(updateFieldInsightsChartVisibility, onUpdateFieldInsightsChartVisibility);
}
